import { QuotaEntity } from '@eastcoal/api/trade/interface'

import { MathOperatorTextMap } from '@eastcoal/shared/enums/MathOperator'
import { QuotaParamsType } from '@eastcoal/shared/enums/QuotaParamsType'

export const getQuotaParamsValue = (quota: QuotaEntity) => {
  return quota.type !== QuotaParamsType.BETWEEN
    ? quota.type && `${MathOperatorTextMap[quota.type]} ${quota.value1 ?? '-'} `
    : `${quota.value1 ?? '-'} ~ ${quota.value2 ?? '-'} `
}
